import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Icon } from '@cld/icon';
import { getActiveViewIdx, getViewsInfo } from 'selectors/views';
import { Stepper, Step } from '@cld/wizard';
import { messages } from '../../../../i18n';

const WizardWrapper = styled.div`
  min-width: 50%;
  padding: 12px 10px;
  margin: 0 auto;
`;

const Wizard = ({ activeIdx, viewsInfo }) => {
  const { formatMessage } = useIntl();
  return (
    <WizardWrapper data-test="wizard">
      <Stepper activeStepIdx={activeIdx}>
        {viewsInfo.map((view) => {
          const defaultMessage = messages[view.label]?.defaultMessage;
          return (
            <Step
              title={defaultMessage}
              key={view.label}
              data-test-specifier={view.label}
              label={formatMessage({
                id: messages[view.label]?.id || view.label,
                defaultMessage,
              })}
            >
              <Icon data-test="viewIcon" name={view.icon} />
            </Step>
          );
        })}
      </Stepper>
    </WizardWrapper>
  );
};
const mapStateToProps = (state) => ({
  activeIdx: getActiveViewIdx(state),
  viewsInfo: getViewsInfo(state),
});

export default connect(mapStateToProps)(Wizard);
